import './App.css';
import React, { useEffect, useState } from 'react';
import Modal from './Modal.js';
import Instructions from './Instructions';
import Game from './Game';
import { Alignment, Button, ButtonGroup } from '@blueprintjs/core';
import stages from './stages.json';

function Adventure() {
  const [stage, setStage] = useState(null);
  const [showInstructions, setShowInstructions] = useState(false);
  const [miningRate, setMiningRate] = useState(0);
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    if (stage === null) {
      return;
    }
    
    if (!complete && miningRate >= stage.scoreToMatch) {
      alert("Congratulations, you've beat the stage!");
      setComplete(true);
    }
  }, [stage, miningRate, complete])

  return (
    <div className="App">
      <ButtonGroup>
        {stage !== null && <Button icon='arrow-left' text='Back' onClick={() => {
          setComplete(false);
            setStage(null);
            setMiningRate(0);
          }}/>}
        <Button icon='info-sign' text='Instructions' onClick={() => setShowInstructions(true)}/>
      </ButtonGroup>

      {stage === null ? 
      <ButtonGroup vertical alignText={Alignment.LEFT} style={{margin: '10px'}}>
        {Object.keys(stages).map((e) => <Button key={e} text={e} onClick={() => setStage(stages[e])} />)}
      </ButtonGroup> : 
      <>
        <p>{stage.description}</p>
        <Game game={stage.game} SetMiningRate={setMiningRate} />
      </>
      }

      {showInstructions && <Modal closeModal={() => { setShowInstructions(false) }}>
        <Instructions />
      </Modal>}
    </div>
  );
}

export default Adventure;
